import { render, staticRenderFns } from "./WorksList.vue?vue&type=template&id=fd4dfa44&scoped=true"
import script from "./WorksList.vue?vue&type=script&lang=js"
export * from "./WorksList.vue?vue&type=script&lang=js"
import style0 from "./WorksList.vue?vue&type=style&index=0&id=fd4dfa44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4dfa44",
  null
  
)

export default component.exports